import { CancelToken } from 'axios';
import { fetchCampaignInvitees } from '@front-app/services/GroupInvitationCampaignApi/InvitationCampaignInviteesApi';
import { FetchInviteesRequestParams, InvitationCampaignInvitee } from '@front-app/services/GroupInvitationCampaignApi/model';
import { ThrottledSearch, useThrottledApi } from './useThrottledApi';

/**
 * This is simplified version of the Content API, intended to be used only for simple searching by name
 * For complex use cases, including proper pagination, consider the groupContentStore
 */
const cancellableSearchCampaignInvitees = (
	cancelToken: CancelToken,
	groupId: string,
	campaignId: string,
	pageNum: number,
	params: FetchInviteesRequestParams,
) => fetchCampaignInvitees(groupId, campaignId, pageNum, params, cancelToken);

export type CampaignInviteeSearchArgs = [groupId: string, campaignId: string, pageNum: number, params: FetchInviteesRequestParams];

export const useThrottledCampaignInviteesSearch = (): ThrottledSearch<CampaignInviteeSearchArgs, InvitationCampaignInvitee[]> => useThrottledApi(
	cancellableSearchCampaignInvitees,
	{
		shouldShortCircuit: () => false,
		emptyResultFactory: () => [],
		catchAndReturnEmptyOnCancellation: true,
	},
);
